import { PanelStatus } from './panel-status';

export type PanelEventBase<TType extends string, TData = unknown> = {
  type: TType;
  data: TData;
};

export interface PanelStatusEvent
  extends PanelEventBase<'panel-status', PanelStatus> {}

export function isPanelStatusEvent(value: unknown): value is PanelStatusEvent {
  if (value === undefined || value === null || typeof value !== 'object') {
    return false;
  }

  const { type, data } = value as PanelStatusEvent;
  return type === 'panel-status' && typeof data === 'string';
}
